import ReportsTravelRuleTable from './ReportsTravelRuleTable'

export default ReportsTravelRuleTable
